import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";

const ImportContactsDialog = ({ open, onClose, onImport, saving }) => {
  const [rawText, setRawText] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const handleImport = async () => {
    setError("");
    setResult(null);
    const importResult = await onImport(rawText);
    if (importResult?.error) {
      setError(importResult.error);
      return;
    }
    setResult(importResult.data);
  };

  const handleClose = () => {
    setRawText("");
    setResult(null);
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>واردسازی شماره موبایل</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          شماره‌ها را در هر خط، با کاما یا فاصله وارد کنید. فرمت‌های 0912...، 912... و +98912... پشتیبانی می‌شود.
        </Typography>
        <TextField
          fullWidth
          multiline
          minRows={8}
          placeholder="09123456789&#10;09121234567"
          value={rawText}
          onChange={(e) => setRawText(e.target.value)}
        />
        {error ? <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert> : null}
        {result ? (
          <Alert severity="success" sx={{ mt: 2 }}>
            کل: {result.total} | جدید: {result.inserted} | تکراری: {result.duplicates} | نامعتبر: {result.invalid}
          </Alert>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>بستن</Button>
        <Button variant="contained" onClick={handleImport} disabled={saving || !rawText.trim()}>
          {saving ? "در حال واردسازی..." : "واردسازی"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportContactsDialog;
